import { useEffect, useState } from 'react';

const USER_MANAGEMENT_ACCESS_KEY = 'user_management_access_token';
const EXPIRATION_TIME = 60 * 60 * 1000; // 1 hour in milliseconds

export const useUserManagementAccess = () => {
  const [isVerified, setIsVerified] = useState(() => {
    const storedTimestamp = localStorage.getItem(USER_MANAGEMENT_ACCESS_KEY);
    if (storedTimestamp) {
      const timeDiff = Date.now() - parseInt(storedTimestamp, 10);
      return timeDiff < EXPIRATION_TIME;
    }
    return false;
  });

  useEffect(() => {
    checkAccess();

    const interval = setInterval(checkAccess, 60000);
    return () => clearInterval(interval);
  }, []);

  const checkAccess = () => {
    const storedTimestamp = localStorage.getItem(USER_MANAGEMENT_ACCESS_KEY);
    if (storedTimestamp) {
      const timeDiff = Date.now() - parseInt(storedTimestamp, 10);
      if (timeDiff < EXPIRATION_TIME) {
        setIsVerified((prev) => (prev ? prev : true));
        return;
      }
    }

    setIsVerified((prev) => {
      if (prev) {
        localStorage.removeItem(USER_MANAGEMENT_ACCESS_KEY);
        return false;
      }
      localStorage.removeItem(USER_MANAGEMENT_ACCESS_KEY);
      return false;
    });
  };

  const grantAccess = () => {
    localStorage.setItem(USER_MANAGEMENT_ACCESS_KEY, Date.now().toString());
    setIsVerified(true);
  };

  const revokeAccess = () => {
    localStorage.removeItem(USER_MANAGEMENT_ACCESS_KEY);
    setIsVerified(false);
  };

  return {
    isVerified,
    grantAccess,
    revokeAccess,
  };
};
